import styles from './PhoneAndNumbers.module.scss'
import { Grid, Box, AchieveTheme } from '@achieve/ascend'
import Section from 'components/Section'
import { CardPhone } from 'components/Cards'
import { TitleDivider } from 'components/TitleDivider'
import { useMemoizedContentGetter } from 'utils/contentful'
import classNames from 'classnames'
import { useBot } from 'hooks/useBot'
import { BOT_PHONE_NUMBER } from 'constants/experiments'

function PhoneAndNumbers({ content }) {
  const { isCrawler } = content
  const { title, subtitle, grid, theme } = useMemoizedContentGetter(content, [
    'title',
    'subtitle',
    'grid',
    'theme',
  ])

  const { isBot } = useBot()

  const fieldName = content?.fieldName

  const backgroundColor = theme?.theme[0]
    ? AchieveTheme?.ascend?.colors?.blue?.[50]
    : AchieveTheme?.ascend?.colors?.neutral?.[0]

  const breakline = ['aboutUsCulture', 'valueSeparatorProps'].includes(fieldName)

  return (
    <Section
      backgroundColor={backgroundColor}
      className={!breakline ? styles['section'] : styles['section-breakline']}
    >
      <Grid
        container
        justifyContent="center"
        data-testid="phone-number-grid-container"
        className={styles['container-grid']}
      >
        <Grid container className={styles['grid-wrapper']}>
          <TitleDivider
            data-testid="phone-number-title-divider"
            className={styles['title-divider-wrapper']}
            title={title}
            subtitle={subtitle}
            component="h2"
            classNameTitleText="displayMd lg:displayLg font-bold"
            classNameSubtitleText="bodySm lg:displaySm font-light"
          />
        </Grid>
        <Grid
          item
          sm={10}
          md={8}
          lg={12}
          data-testid="phone-number-grid-card-container"
          className={classNames(styles['card-grid'], { [styles['breakline']]: breakline })}
        >
          {grid?.gridItemsCollection?.items?.map((item, idx) => {
            const card = (
              <Box
                data-testid={`phone-number-grid-card-${idx}`}
                className={styles['phone-number-grid-card']}
                key={`card-${idx}`}
              >
                <CardPhone
                  content={isBot || isCrawler ? { ...item, cardText: BOT_PHONE_NUMBER } : item}
                  breakline={breakline}
                />
              </Box>
            )
            const separator = (
              <Box
                data-testid={`phone-number-grid-separator-${idx}`}
                className={styles['phone-number-grid-separator']}
                key={`separator-${idx}`}
              ></Box>
            )
            if (idx > 0) {
              return [separator, card]
            }
            return card
          })}
        </Grid>
      </Grid>
    </Section>
  )
}
export { PhoneAndNumbers }
export default PhoneAndNumbers
